import { useAuth } from '../contexts/AuthContext'
import { useTranslation } from '../i18n'
import { ErrorMessage } from './ui'

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isLoading, isAuthenticated, error } = useAuth()
  const { translate } = useTranslation()

  if (isLoading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center p-5"
      >
        <div className="text-center">
          <div className="text-6xl mb-4">⏳</div>
          <p className="text-lg font-semibold">{translate('auth.authenticating')}</p>
          <p className="text-sm opacity-70 mt-2">{translate('auth.pleaseWait')}</p>
        </div>
      </div>
    )
  }

  if (error || !isAuthenticated) {
    return (
      <ErrorMessage
        title={translate('auth.authenticationFailed')}
        message={error || translate('auth.unableToAuthenticate')}
        icon="⚠️"
        onRetry={() => window.location.reload()}
        retryLabel={translate('auth.retry')}
        fullScreen
      />
    )
  }

  return <>{children}</>
}
